// import Vue from 'vue'
import { createStore } from 'vuex'
import mutations from './mutations'
import getters from './getters'

//Vue.use(Vuex)

const state = {
  user: null,
  req: {},
  oldReq: {},
  clipboard: {
    key: '',
    items: [],
  },
  jwt: '',
  progress: 0,
  loading: false,
  reload: false,
  selected: [],
  multiple: false,
  show: null,
  showShell: false,
  showMessage: null,
  showConfirm: null,
}

export default createStore({
  strict: true,
  state,
  getters,
  mutations,
})
